import { ButtonDeleteRow, Table } from "mta-rkvr-styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { get, remove } from "../api/fetch";
import { InvestmentProjectMessagesResponseBody } from "../api/HomePageResponseTypes";
import { UNIT_MANAGEMENT } from "../util/paths";
import { toLocaleDate } from "../util/conversionUtils";
import { Paginator } from "../types/util/TableFunctionalityTypes";
import { InvestmentProjectMessageMapped, ColumnHeader } from "../types/homepage/InvestmentProjectMessages";
import { TabNames } from "../types/realEstateUnit/UnitManagementTypes";

const InvestmentProjectMessages = () => {
  const { t } = useTranslation();
  const tBase = "homePageAuth.investmentProjectMessages.";

  const [messages, setMessages] = useState<InvestmentProjectMessageMapped[]>();
  const [refreshObservable, setRefreshObservable] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const refresh = () => {
    setRefreshObservable(!refreshObservable);
  };
  const [paginator, setPaginator] = useState<Paginator>();
  const onPagination = (paginator: { pageSize: number; elementOffset: number }) => {
    getMessages(paginator.pageSize, paginator.elementOffset);
  };
  useEffect(() => {
    getMessages();
  }, [refreshObservable]);

  const getMessages = (pageSize?: number, elementOffset?: number) => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    get<InvestmentProjectMessagesResponseBody>({
      endPoint: "investmentProjectHomePageMessages",
      queryParams: [
        { name: "limit", value: pageSize ? pageSize : 10 },
        { name: "offset", value: elementOffset ? elementOffset : 0 },
      ],
    }).then(async ({ ok, body }) => {
      if (ok) {
        setMessages(
          body.resultsList.map((message) => {
            return {
              ...message,
              saadetud: toLocaleDate(message.saadetud),
            };
          }),
        );
        setLoading(false);
        setPaginator({
          pageSize: body.limit,
          elementOffset: body.offset,
          numberOfElements: body.resultCount,
          totalElements: body.totalCount,
        });
      } else {
        console.error("Failed to load investment messages. ");
      }
    });
  };

  const markDone = (id: number) => {
    remove<never>({ endpoint: "removeInvestmentProjectHomePageMessage", pathParams: [id] }).then((res) => {
      res.ok && refresh();
    });
  };
  if (messages == undefined) {
    return (
      <Table
        id={t(tBase + "title")}
        title={t(tBase + "title")}
        headers={Object.keys(ColumnHeader).map((header) => {
          return t(tBase + header);
        })}
        content={[]}
        translate={t}
        loading
      />
    );
  }

  const groupReceivers = (arr: string[] | undefined): (JSX.Element | string)[] | string => {
    if (arr == undefined || arr.length == 0) return "";

    if (arr.length == 1) return arr[0];

    const returnable: (JSX.Element | string)[] = [];
    for (let i = 0; i < arr.length; i++) {
      returnable.push(arr[i]);
      if (i < arr.length - 1) {
        returnable.push(<br />);
      }
    }
    return returnable;
  };

  const translateContent = (txtCode: string, ipCode: string): string => {
    return t(`${tBase}messages.${txtCode}`, { ipkood: ipCode }).toString();
  };

  return (
    <>
      {messages && (
        <>
          <Table
            id={t(tBase + "title")}
            title={t(tBase + "title")}
            headers={Object.keys(ColumnHeader).map((header) => {
              return t(tBase + header);
            })}
            paginator={paginator}
            onPagination={onPagination}
            loading={isLoading}
            content={messages.map((message) => {
              const { saadetud, sisu, kommentaar, taotluseKood, ipId, kvyId, saaja } = message;
              const to = groupReceivers(saaja);
              const o: any = {
                code: (
                  <Link to={`${UNIT_MANAGEMENT}/${kvyId}/${TabNames.investeeringuprojekt}/${ipId}`}>
                    {taotluseKood}
                  </Link>
                ),
                saadetud,
                sisu: translateContent(sisu, taotluseKood),
                kommentaar,
                to: to,
              };
              return o;
            })}
            translate={t}
            wrapBigColumns
            subTables={{
              headers: [t(tBase + "content"), t(tBase + "comment")],
              contents: messages.map((message) => {
                return [
                  {
                    teade: translateContent(message.sisu, message.taotluseKood),
                    sisu1: message.kommentaar,
                  },
                ];
              }),
              togglers: ["sisu", "kommentaar"],
            }}
            rowIds={messages.map((message) => message.id)}
            editable
            customEditRowComponent={(obj: { rowId: number }) => (
              <>
                <ButtonDeleteRow
                  onConfirm={() => {
                    markDone(obj.rowId);
                  }}
                  confirmationText={t(`${tBase}confirmRemove`)}
                />
              </>
            )}
          />
        </>
      )}
    </>
  );
};

export default InvestmentProjectMessages;
